export * from './shadow-type-4.component';